module.exports = __webpack_public_path__ + "img/drug-29.c0999da4.png";